module.exports = function(a){
	return typeof a === 'number' || a instanceof Number;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mutype/is-number.js
// module id = rFVf
// module chunks = 0